import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';
import { TaxIncomeDocumentShareholdersType } from 'modules/partners/components/PartnerAside/utils/generateTaxIncomeDocument';

type GetOperationDataForTax193Props = {
  fiscalYear: number;
  societyId: string;
  shareholdersType: TaxIncomeDocumentShareholdersType;
};

export const getOperationDataForTax193 =
  ({
    fiscalYear,
    societyId,
    shareholdersType,
  }: GetOperationDataForTax193Props) =>
  async (dispatch: Dispatch) => {
    const query = { params: { fiscalYear, societyId, shareholdersType } };
    try {
      const { data } = await axiosV2.get(`/operations/data-for-tax-193`, query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
